import React from 'react';
import { useFormState } from 'react-final-form';

import FeatureWrapper from '../../ai-features/feature-wrapper/FeatureWrapper';
import AIAssistantsContainer from '../../ai-features/ai-assistants-container/AIAssistantsContainer';
import AIChatsContainer from '../../ai-features/ai-chats-container/AIChatsContainer';
import AIMediaContainer from '../../ai-features/ai-media-container/AIMediaContainer';

import scss from './AIFeatures.module.scss';

function AIFeatures() {
  const { submitting } = useFormState();

  return (
    <div className={scss.aiFeatures}>
      <FeatureWrapper title='AI Assistants' isSaving={submitting}>
        {({ search, disabled }) => (
          <AIAssistantsContainer search={search} disabled={disabled} fieldName='assignedAssistants' />
        )}
      </FeatureWrapper>
      <FeatureWrapper title='AI Chats' isSaving={submitting}>
        {({ search, disabled }) => <AIChatsContainer search={search} disabled={disabled} fieldName='assignedAIChats' />}
      </FeatureWrapper>
      <FeatureWrapper title='AI Media' isSaving={submitting}>
        {({ search, disabled }) => <AIMediaContainer search={search} disabled={disabled} fieldName='assignedAIMedia' />}
      </FeatureWrapper>
    </div>
  );
}

export default AIFeatures;
